import StaffList from './staff_list.vue'

export default {
    path: 'staffList',
    component: StaffList
}
